module.exports = __webpack_public_path__ + "img/nebula.f848b9b3.png";